const state = {
    loadingModule: [],
    kb_item: [],
    kb_menu: [],
    flatList: [],
    paging: {},
    support_tickets: {},
    search_kb_items: [],
    showUserPermissionsAdvancedSettings: false
}
const mutations = {
    UPDATE_LOADING_MODULE(state, { value, remove }) {
        if (remove) {
            state.loadingModule.splice(state.loadingModule.indexOf(value), 1)
        } else if (state.loadingModule.indexOf(value) == -1) {
            state.loadingModule.push(value)
        }
    },
    UPDATE_PROPERTY(state, { property, value }) {
        state[property] = value
    },
    UPDATE_SUPPORT_TICKETS(state, { page, filters, tickets }) {
        state.support_tickets = tickets
    },
    UPDATE_SUPPORT_TICKET_LIST(state, { tickets }) {
        state.support_tickets = tickets
    },
    TOGGLE_SHOW_USER_PERMISSIONS_ADVANCED_SETTINGS(state) {
        state.showUserPermissionsAdvancedSettings = !state.showUserPermissionsAdvancedSettings
    }
}
const getters = {
    getLoadingModule: state => state.loadingModule.length > 0,
    getKBItem: state => state.kb_item,
    getKBMenu: state => state.kb_menu,
    getFlatList: state => state.flatList,
    getPaging: state => state.paging,
    getSupportTickets: state => state.support_tickets,
    getSearchKbItems: state => state.search_kb_items,
    getShowUserPermissionsAdvancedSettings: state => state.showUserPermissionsAdvancedSettings
}
const actions = {
    bootstrapModule({ state, commit, dispatch, rootState }) {
        rootState.source = 'DASHBOARD'
    },
    constructFlatList({ state, dispatch }, items) {
        for (var i = 0; i < items.length; i++) {
            state.flatList.push(items[i].kb_item_id)
            if (items[i].sub_menu.length > 0) {
                dispatch('constructFlatList', items[i].sub_menu)
            }
        }
    },
    updateLoadingModule({ commit }, { value, remove }) {
        commit('UPDATE_LOADING_MODULE', { value: value, remove: remove })
    },
    updateKBMenu({ state, commit, dispatch }, value) {
        commit('UPDATE_PROPERTY', { property: 'kb_menu', value: value })
    },
    updateKBItem({ state, commit, dispatch }, value) {
        commit('UPDATE_PROPERTY', { property: 'kb_item', value: value })
    },
    updateSupportTicketList({ commit }, tickets ) {
        commit('UPDATE_SUPPORT_TICKET_LIST', { tickets })
    },
    updateSearchKbItems({ commit }, value) {
        commit('UPDATE_PROPERTY', { property: 'search_kb_items', value: value })
    },
    toggleShowUserPermissionsAdvancedSettings({ commit }) {
        commit('TOGGLE_SHOW_USER_PERMISSIONS_ADVANCED_SETTINGS')
    },
    fetchSupportTickets({ state, commit, dispatch }, parameters) {
        return new Promise((resolve, reject) => {
            var data = {
                page: parameters.page
            }
            if (parameters.query) {
                data.search_term = parameters.query.search_term
                data.filter = parameters.query["filter"]
                data.sort = parameters.query["sort"]
            }
            this.dispatch('apiCall', { destination: 'get_list_support_tickets', data: data }, { root: true }).then(obj => {
                commit('UPDATE_PROPERTY', { property: 'support_tickets', value: obj.support_tickets })
                resolve()
            }).catch(err => {
                reject(err)
                console.log(err);
            })
        })
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
